import { render, staticRenderFns } from "./YouTube.vue?vue&type=template&id=7868c556"
import script from "./YouTube.vue?vue&type=script&lang=js"
export * from "./YouTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7868c556')) {
      api.createRecord('7868c556', component.options)
    } else {
      api.reload('7868c556', component.options)
    }
    module.hot.accept("./YouTube.vue?vue&type=template&id=7868c556", function () {
      api.rerender('7868c556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/YouTube.vue"
export default component.exports